<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row class="flex-nowrap" v-if="unidadeId">

                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="Unidade"
                        v-model="form.unidade"
                        disabled
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="Local de atendimento"
                        v-model="form.infraestrutura"
                        disabled
                    />
                </rkm-col>
            </rkm-row>

            <rkm-area
                type="section"
                title="Inclusão de nova jornada"
            >

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-row class="flex-nowrap">
                            <rkm-col cols="6">
                                <rkm-row>

                                    <rkm-col cols="4">
                                        <rkm-form-select
                                            ref="tipoId"
                                            :options="form.tipos"
                                            label="Tipo de Jornada"
                                            show-default-option
                                            text-field="nome"
                                            v-model="jornada.tipoId"
                                            value-field="id"
                                            :validations="validations.tipoId"
                                            :disabled="this.index == null ? false : true"
                                            @change="resetForm"
                                        />
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1">
                                        <rkm-form-date-picker
                                            ref="periodo"
                                            range
                                            :range-inline="false"
                                            start-label="Período de"
                                            end-label="Até"
                                            v-model="jornada.periodo"
                                            :min-date="form.minDate"
                                            :max-date="form.maxDate"
                                            :start-validations="validations.periodo.start"
                                            :end-validations="validations.periodo.end"
                                            :disabled="this.index == null ? false : true"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>

                                    <rkm-col cols="12">
                                        <rkm-form-checkbox-group
                                            label="Dias da semana"
                                            v-model="jornada.diasSemana"
                                            :options="form.diasSemana"
                                            text-field="nome"
                                            value-field="id"
                                            buttons
                                            button-color="outline-primary"
                                            :validations="validations.diasSemana"
                                            small
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>

                                    <rkm-col class="flex-grow-1">
                                        <rkm-form-time-picker
                                            ref="horaInicial"
                                            label="Horário Inicial"
                                            v-model="jornada.horaInicial"
                                            :validations="validations.horaInicial"
                                        />
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1">
                                        <rkm-form-time-picker
                                            ref="horaFim"
                                            label="Horário Final"
                                            v-model="jornada.horaFim"
                                            :validations="validations.horaFim"
                                            :disabled="jornada.tipoId !== enums.tipoJornada.FIXA"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>

                                    <rkm-col class="flex-grow-1">
                                        <rkm-form-input
                                            ref="vagas"
                                            label="Número de vagas"
                                            number
                                            v-model="jornada.vagas"
                                            :validations="validations.vagas"
                                            @change="handleBlur"
                                        />
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1" v-if="form.habilitaAgendamentoApp">
                                        <rkm-form-input
                                            ref="vagasApp"
                                            label="Vagas APP Cidadão"
                                            tooltip-top="Informe aqui a quantidade de vagas reservadas ao APP Cidadão. Essas vagas serão somadas às vagas normais para cálculo automático do tempo de atendimento."
                                            number
                                            v-model="jornada.vagasApp"
                                            @change="handleBlur"
                                        />
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1" v-if="index !== null">
                                        <rkm-form-input
                                            ref="utilizadas"
                                            label="Vagas utilizadas"
                                            number
                                            v-model="jornada.agendamentos"
                                            disabled
                                        />
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1">
                                        <rkm-form-input
                                            ref="tempoAtendimento"
                                            label="Tempo de atendimento"
                                            :disabled="jornada.tipoId !== enums.tipoJornada.DINAMICA"
                                            v-model="jornada.tempoAtendimento"
                                            :validations="validations.tempoAtendimento"
                                            @change="handleBlur"
                                        >
                                            <rkm-input-group-append slot="append">
                                                <rkm-input-group-text>
                                                    em minutos.
                                                </rkm-input-group-text>
                                            </rkm-input-group-append>
                                        </rkm-form-input>
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="form.habilitaAgendamentoApp">
                                    <rkm-col class="flex-grow-1">
                                        <rkm-form-select
                                            ref="laboratorioPrestadorInfraestruturaId"
                                            label="Laboratório prestador"
                                            tooltip-top="Selecione o laboratório prestador responsável por esta jornada para permitir o controle correto da agenda e das cotas do APP Cidadão."
                                            :options="form.laboratorios"
                                            show-default-option
                                            text-field="nome"
                                            value-field="id"
                                            v-model="jornada.laboratorioPrestadorInfraestruturaId"
                                            :validations="validations.laboratorioPrestadorInfraestruturaId"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>

                                    <rkm-col class="flex-grow-1">
                                        <rkm-button
                                            @click.stop="add"
                                            color="primary"
                                        >
                                            {{ index !== null ? 'Alterar Jornada' : 'Incluir jornada' }}
                                        </rkm-button>

                                        <rkm-button
                                            @click="cancelForm"
                                            color="primary"
                                        >
                                            {{ index == null ? 'Limpar' : 'Voltar' }}
                                        </rkm-button>
                                    </rkm-col>
                                </rkm-row>

                            </rkm-col>
                            <rkm-col class="flex-grow-1">

                                <rkm-calendar
                                    :items="diasCalendario"
                                    @click="openModal"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <Modal
            ref="Modal"
            :model="model"
            :habilita-agendamento-app="form.habilitaAgendamentoApp"
            @handleAlter="handleAlter"
        />
    </div>
</template>

<script>

// Mixins.
import { error, repository, stringCase, object, data, calculations, formats } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Enuns.
import tipoJornada from '@/enums/exame-laboratorial/tipoJornada'
import modulo from '@/enums/cadastro/feriado/modulo'

// Components.
import Modal from '@/components/exame-laboratorial/jornada/components/cadastro/Modal'

// Moment.
import moment from 'moment'

export default {
    components: { Modal },
    computed:{
        validations() {
            return {
                unidadeId: { required: true },
                infraestruturaId: { required: true },
                tipoId: { required: true },
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                diasSemana: { required: true },
                horaInicial: {
                    required: true,
                    max_hour: this.jornada.primeiroHorario
                        ? this.formatTime(this.jornada.primeiroHorario)
                        : this.getMaxHour()
                },
                horaFim: {
                    required: true,
                    min_hour: this.jornada.ultimoHorario
                        ? this.formatTime(this.jornada.ultimoHorario)
                        : this.getMinHour()
                },
                vagas: { required: true, min_value: this.jornada.agendamentos ?? 1 },
                tempoAtendimento: { required: true },
                laboratorioPrestadorInfraestruturaId: { required: !!this.jornada.vagasApp },
            }
        },
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('exameLaboratorial.jornada'),
            feriado: this.getConectaSusRepository('cadastro.feriado.feriado')
        }
    },
    data: () => ({
        isReadOnly: false,
        dataAtual: '',
        tabIndex: 1,
        checkData: '',
        enums: {
            tipoJornada,
            modulo
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleBlur(){

            const jornada = this.jornada
            const totalVagas = parseInt(jornada.vagas || 0) + parseInt(jornada.vagasApp || 0)

            if (this.jornada.tipoId == this.enums.tipoJornada.FIXA) {

                if(this.jornada.horaInicial && this.jornada.horaFim){

                    jornada.horaInicial = this.jornada.horaInicial.substr(0, 5)
                    jornada.horaFim = this.jornada.horaFim.substr(0, 5)

                    var inicioHoraHandle = jornada.horaInicial.split(':')
                    var fimHoraHandle = jornada.horaFim.split(':')

                    var inicioTratado = parseInt(inicioHoraHandle[0]* 60) + parseInt(inicioHoraHandle[1])
                    var finalTratado = parseInt(fimHoraHandle[0]* 60) + parseInt(fimHoraHandle[1])

                    var diferencaMinutos = finalTratado - inicioTratado

                    if(totalVagas){

                        jornada.tempoAtendimento = Math.floor(diferencaMinutos / totalVagas)
                    }
                }
            } else {

                if(this.jornada.horaInicial && this.jornada.tempoAtendimento && totalVagas){

                    jornada.horaInicial = this.jornada.horaInicial.substr(0, 5)
                    jornada.tempoAtendimento = this.jornada.tempoAtendimento

                    let totalMinutos = jornada.tempoAtendimento * totalVagas

                    var horarioFinal = moment(jornada.horaInicial, "HH:mm")
                        .add(totalMinutos, 'minutes')
                        .format('HH:mm');

                    jornada.horaFim = horarioFinal
                }
            }
        },
        add() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                    var inicio = moment(this.jornada.periodo.start, 'YYYY/MM/DD');
                    var fim = moment(this.jornada.periodo.end, 'YYYY/MM/DD');

                    var diaInicio   = inicio.format('D');
                    var mesInicio = inicio.format('M');
                    var anoInicio  = inicio.format('YYYY');

                    var diaFim   = fim.format('D');
                    var mesFim = fim.format('M');
                    var anoFim  = fim.format('YYYY');

                    var dataInicio = new Date(anoInicio,mesInicio - 1,diaInicio);
                    var dataFinal = new Date(anoFim,mesFim -1 ,diaFim);

                    let msg = ''

                    for (var dataInserida = dataInicio; dataInserida <= dataFinal; dataInserida.setDate(dataInserida.getDate() + 1)) {

                        const jornada = this.clone(this.jornada)

                        if (this.jornada.tipoId == this.enums.tipoJornada.DINAMICA) {

                            if(this.jornada.tempoAtendimento <= 0){

                                this.showValidationNotification("O tempo de atendimento deve ter ao menos um minuto.")

                                this.jornada.tempoAtendimento = ''
                                this.jornada.vagas = ''

                                return
                            }
                        }

                        jornada.unidadeId = this.unidadeId
                        jornada.infraestruturaId = this.infraestruturaId

                        jornada.horaInicial = this.jornada.horaInicial.substr(0, 5)
                        jornada.horaFim = this.jornada.horaFim.substr(0, 5)

                        jornada.tipoNome = this.form.tipos.find(s => s.id === jornada.tipoId).nome

                        jornada.data = this.getFormatedDate(dataInserida, 'DD/MM/YYYY')

                        jornada.diasSemana.forEach((diaSemana) => {

                            var data = moment(jornada.data, 'DD/MM/YYYY').toDate()
                            var dia = data.getDay() + 1;

                            if (dia === diaSemana){

                                jornada.semanaId = dia

                                this.checkData = jornada.data

                                let existeFeriado = false

                                this.form.feriados.find((j) => {

                                    j.modulos.map(modulo => {

                                        if(modulo == this.enums.modulo.EXAME_LABORATORIAL) {

                                            if(j.data == jornada.data){

                                                existeFeriado = true

                                                const verificaFeriado = [j.data]

                                                for( let i = 0; i < verificaFeriado.length; i++) {

                                                    msg = msg.concat('<br/> - ', verificaFeriado[i], ' - Feriado e/ou ponto facultativo.')
                                                }
                                            }
                                        }
                                    })
                                })

                                if(!existeFeriado){

                                    const existeJornada = this.model.jornadas.find(j => {

                                        const horaInicial = moment(jornada.data.concat(' ', this.jornada.horaInicial), 'DD/MM/YYYY HH:mm:ss')
                                        const horaFinal = moment(jornada.data.concat(' ', this.jornada.horaFim), 'DD/MM/YYYY HH:mm:ss')

                                        return j.jornadaId !== this.jornada.jornadaId && moment(horaInicial).isBetween(
                                            moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm'),
                                            moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm')
                                        )
                                        ||
                                        j.jornadaId !== this.jornada.jornadaId && moment(horaFinal).isBetween(
                                            moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm'),
                                            moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm')
                                        )
                                        ||
                                        j.jornadaId !== this.jornada.jornadaId && moment(horaInicial).isSame(
                                            moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm:ss')
                                        )
                                        ||
                                        j.jornadaId !== this.jornada.jornadaId && moment(horaFinal).isSame(
                                            moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm:ss')
                                        )
                                        ||
                                        j.jornadaId !== this.jornada.jornadaId && moment(
                                            this.getFormatedDate(horaInicial, 'DD/MM/YYYY HH:mm')
                                        )
                                        .isBefore(
                                            j.data.concat(' ', j.horaInicial),
                                        )
                                        && moment(this.getFormatedDate(horaFinal, 'DD/MM/YYYY HH:mm'))
                                        .isAfter(
                                            j.data.concat(' ', j.horaFim),
                                        )
                                    })

                                    const verificaData = [jornada.data]

                                    if(existeJornada){

                                    for( let i = 0; i < verificaData.length; i++) {

                                            msg = msg.concat('<br/> - ', verificaData[i], ' - Conflito de horário.')
                                        }
                                    }

                                    if(!existeJornada){

                                        this.diasCalendario.push(
                                            {
                                                'dates': data,
                                                'title': 'icon-search',
                                                'highlight': 'green'
                                            }
                                        )

                                        const laboratorioPrestador = this.form.laboratorios
                                            ? this.form.laboratorios.find(l => l.id === jornada.laboratorioPrestadorInfraestruturaId)
                                            : null
                                        jornada.laboratorioPrestadorNome = laboratorioPrestador ? laboratorioPrestador.nome : null

                                        if( this.index == null ){

                                            jornada.jornadaId = this.uniqueId()
                                            jornada.agendamentos = 0
                                            jornada.vagasDisponiveis = parseInt(jornada.vagas || 0) + parseInt(jornada.vagasApp || 0)

                                            this.model.jornadas.push(jornada)

                                            this.sucessAdd()
                                            this.$emit('search')
                                            this.$nextTick(() =>  this.mensagemConflito(msg))
                                        } else {

                                            const index = this.model.jornadas.findIndex(item => item.jornadaId == jornada.jornadaId)

                                            jornada.vagasDisponiveis = (parseInt(jornada.vagas || 0) + parseInt(jornada.vagasApp || 0)) - jornada.agendamentos

                                            this.$set(this.model.jornadas, index, this.clone(jornada))

                                            this.$emit('search')
                                            this.sucessAdd()
                                            this.$nextTick(() =>  this.mensagemConflito(msg))
                                        }
                                    } else {

                                        this.mensagemConflito(msg)
                                    }
                                } else {

                                    this.mensagemConflito(msg)
                                }
                            }
                        })
                    }

                    this.$refs.Form.resetValidator()
                })
        },
        openModal(item){

            const diaTratado = moment(item.date).format('DD/MM/YYYY')

            var data = moment(item.date, 'DD/MM/YYYY').toDate()
            var semanaId = data.getDay() + 1;

            const diaSelecionado = this.model.jornadas.find(
                dias => dias.data == diaTratado
            )

            if(diaSelecionado){

                const diaSelecionadoModal = this.model.jornadas.filter(p => p.data == diaTratado)

                this.$refs.Modal.open(item, diaSelecionadoModal, diaTratado, semanaId)
            }
        },
        mensagemConflito(msg){

            if(msg){

                this.showAlert('Não foi possível cadastrar a jornada nas seguintes datas: '  + msg)
            }
        },
        cancelForm(){

            this.$emit('backTabs')

            this.disabledSemanas()
        },
        sucessAdd(){

            this.$emit('backTabsNotification')
        },
        validate() {

            return this.$refs.Form.validate()
        },
        disabledSemanas(){

            this.form.diasSemana.forEach(s => s.disabled = true)
        },
        resetForm(){

            this.jornada.horaInicial = ''
            this.jornada.horaFim = ''
            this.jornada.vagas = ''
            this.jornada.vagasApp = ''
            this.jornada.laboratorioPrestadorInfraestruturaId = null
            this.jornada.tempoAtendimento = ''
            this.jornada.periodo.start = ''
            this.jornada.periodo.end = ''
        },
        handleAlter(item, index) {
            this.$emit('handleAlter', item, index)
        },
        getMaxHour() {

            const horario = this.jornada.horaFim

            if (horario) {

                return moment(horario, 'HH:mm').subtract(1, 'minutes').format('HH:mm')
            }

            return false
        },
        getMinHour() {

            const horario = this.jornada.horaInicial

            if (horario) {

                return moment(horario, 'HH:mm').add(1, 'minutes').format('HH:mm')
            }

            return false
        },
    },
    mounted(){

        this.$refs.Form.resetValidator()
    },
    mixins: [ error, repository, stringCase, object, data, calculations, formats],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        jornada: { type: Object, required: true },
        diasCalendario: { type: Array, required: true },
        index: { type: Number, default: null },
        id: { type: Number },
        unidadeId: { type: Number },
        infraestruturaId: { type: Number }
    },
    watch: {
        'jornada.horaInicial': function () {

            this.handleBlur()
        },
        'jornada.horaFim': function () {

            this.handleBlur()
        },
        'unidadeId': function () {

            this.unidade = this.unidadeId
            this.infraestrutura = this.infraestruturaId
        },
        'model.jornadas': function () {

            const jornadasAgrupadas = this.model.jornadas.reduce((agrupammento, unidade) => {
                const dataFormatada = moment(unidade.data, 'DD/MM/YYYY').format('YYYY-MM-DD');

                if (!agrupammento[dataFormatada]) {
                    agrupammento[dataFormatada] = {
                        dates: moment(unidade.data, 'DD/MM/YYYY').toDate(),
                        agendamentos: 0,
                        vagas: 0,
                    };
                }

                agrupammento[dataFormatada].agendamentos += parseInt(unidade.agendamentos);
                agrupammento[dataFormatada].vagas += parseInt(unidade.vagas || 0) + parseInt(unidade.vagasApp || 0);

                return agrupammento;
            }, {});

            const diasCalendario = Object.values(jornadasAgrupadas).map(unidade => ({
                dates: unidade.dates,
                title: `${unidade.agendamentos}/${unidade.vagas}`,
                highlight: unidade.agendamentos >= unidade.vagas ? 'red' : 'green'
            }));

            this.form.feriados.map(feriado =>

                feriado.modulos.map(modulo => {

                    if(modulo == this.enums.modulo.EXAME_LABORATORIAL){

                        diasCalendario.push({
                            'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                            'highlight': 'yellow',
                            'title': feriado.tipoNome,
                            'popover':  feriado.observacao
                        })
                    }
                })
            )

            this.$emit('loadDiasCalendario', diasCalendario)
        },
        'jornada.periodo': {
            deep: true,
            handler: function (periodo) {

                this.jornada.diasSemana = []
                this.disabledSemanas()

                if(periodo.end){

                    var periodoInicial = moment(periodo.start, 'YYYY/MM/DD');
                    var periodoFinal = moment(periodo.end, 'YYYY/MM/DD');

                    var diaInicial   = periodoInicial.format('D');
                    var mesInicial = periodoInicial.format('M');
                    var anoInicial  = periodoInicial.format('YYYY');

                    var diaFinal   = periodoFinal.format('D');
                    var mesFinal = periodoFinal.format('M');
                    var anoFinal  = periodoFinal.format('YYYY');

                    var dataInicial = new Date(anoInicial,mesInicial - 1,diaInicial);
                    var dataFim = new Date(anoFinal,mesFinal -1 ,diaFinal);

                    for (var dataInserida = dataInicial; dataInserida <= dataFim; dataInserida.setDate(dataInserida.getDate() + 1)) {

                        var data = moment(dataInserida, 'DD/MM/YYYY').toDate()

                        var dia = data.getDay() + 1;

                        if(!this.jornada.diasSemana.find(d => d == dia)){

                            if (moment(this.jornada.periodo.start, 'YYYY/MM/DD').isSame(this.jornada.periodo.end, 'YYYY/MM/DD')) {

                                this.jornada.diasSemana.push(dia)
                            }
                        }
                    }

                } else {

                    if(periodo.start){

                        var dataStart = moment(periodo.start, 'DD/MM/YYYY').toDate()

                        var diaStart = dataStart.getDay() + 1;

                        if(!this.jornada.diasSemana.find(d => d == diaStart)){

                            if (moment(this.jornada.periodo.start, 'YYYY/MM/DD').isSame(this.jornada.periodo.end, 'YYYY/MM/DD')) {

                                this.jornada.diasSemana.push(diaStart)
                            }
                        }
                    }
                }

                if(periodo.start || periodo.end){

                    let indices = []

                    if(periodo.start){

                        let dataStart = moment(periodo.start, 'DD/MM/YYYY').toDate()
                        const index = this.form.diasSemana.findIndex(d => d.id == dataStart.getDay() + 1)
                        indices.push(index)
                    }

                    if(periodo.end){

                        let dataEnd = moment(periodo.end, 'DD/MM/YYYY').toDate()
                        const index = this.form.diasSemana.findIndex(d => d.id == dataEnd.getDay() + 1)
                        indices.push(index)
                    }

                    if(periodo.start && periodo.end){

                        indices = []

                        let dataStart = moment(periodo.start, 'DD/MM/YYYY')
                        let dataEnd = moment(periodo.end, 'DD/MM/YYYY')

                        let indice = 0

                        while (dataStart.isSameOrBefore(dataEnd) && indice < 7) {

                            const index = this.form.diasSemana.findIndex(d => d.id == dataStart.toDate().getDay() + 1)
                            indices.push(index)

                            dataStart.add(1, 'd')

                            indice++
                        }
                    }
                    indices.forEach(indice => {

                        this.form.diasSemana[indice].disabled = false
                    })
                }
            }
        }
    }
}
</script>

<style scoped>
.calendario {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.calendario img {
    max-width: 100%;
    max-height: 100%;
    margin: 1rem 0;
}
.form-group-radio-button-disabled, .form-group-checkbox-button-disabled {
    width: 100%
}

</style>